import React from 'react';
import { HashLink } from 'react-router-hash-link';
import '../components/_buttons.scss'; // Asegúrate de que esta ruta esté bien configurada

const ButtonAesthetic = ({ text, outline = false, href, onClick }) => {
  const className = `btn-aesthetic ${outline ? 'outline' : ''}`;

  return (
    <HashLink
      smooth
      to={href || '#'}
      onClick={onClick}
      className={className}
    >
      {text}
    </HashLink>
  );
};

export default ButtonAesthetic;
